import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import {
  viewOrder,
  checkAddressAvailability,
  saveUserAddress,
  setCheckoutDetailConfirmed,
  saveUserpaymentDetails,
} from "../../redux/actionCreators/orderAndPayments"
import { invitePartnerToChat } from "../../redux/actionCreators/invitePeople"
import {
  savePreferences,
  fetchAddressAutoComplete,
} from "../../redux/actionCreators/auth"
import "./CheckoutPage.scss"
import { Form, AutoComplete } from "antd"
import { validateUserAddress } from "../../redux/actionCreators/planDinnner"
import _ from "../../utils/lodashUtils"
import {
  CONFIRM_DETAILS,
  USER_ADDRESS,
  ORDER_LABEL,
  CONFIRM_BUTTON,
  YOU_PAY_BOTH,
  YOU_PAY_SELF,
  CHANGE_ADDRESS_TITLE,
  CHANGE_ADDRESS_WARNING,
  FIRST_NAME,
  EMAIL,
  PARTNER_ORDERS,
  LAST_NAME,
  PHONE_REQUIRED_PLACEHOLDER,
  SAVE_FUTURE_TEXT,
  PARTNER_GO_BACK_FROM_CHECKOUT_DETAIL,
  BACK_FROM_CHECKOUT_DETAIL,
  GO_BACK_FROM_CHECKOUT_DETAIL,
  SAVE_BUTTON,
  CANCEL,
  NOT_CHARGED,
  GO_BACK_CONTENT,
  PARTNER_PAY_BOTH,
  YOUR,
  INVALID_MOBILE,
  INVALID_FLAG_SELECTED,
  PHONE_NUMBER_REQUIRED,
  TOTAL,
} from "../../constants/messages"
import {
  FirebaseService,
  FIREBASE_STATE_KEYS,
  FirebaseContext,
} from "../../firebase"
import { usePrevious } from "common-custom-hooks"
import BlockingModal from "../../components/BlockingModal/BlockingModal"
import { withFormik } from "formik"
import { CheckPaymentDetailsValidation } from "../../validationSchema/CardDetailsValidation"
import OrderDetails, {
  PriceBreakdown,
} from "../../components/OrderDetails/OrderDetails"
import { ADDRESS_NOT_DELIVERABLE } from "../../constants/notificationMsg"
import { ArrowLeftOutlined, EditFilled } from "@ant-design/icons"
import CheckoutPartnerAway from "./CheckoutPartnerAway"
import {
  CustomModal as Modal,
  TextTag as Text,
  Input,
  Button,
  PhoneInput,
} from "../../atoms"
import { PageHeader } from "../../molecules/PageHeader"
import {
  getGenderSpecificMessage,
  getPartnerNameorNickName,
} from "../../utils/helpers"
import { createCombinedOrderPriceBreakdown } from "../../utils/paymentHelper"
import RestaurantNameHeader from "../../components/RestaurantNameHeader/RestaurantNameHeader"
import { checkCheckoutPartnerAway } from "../../utils/helpers"
import checkbox from "../../assets/images/checkbox-tick.svg"
import checkboxUntick from "../../assets/images/checkbox-untick.svg"

const S = props => {
  //page to enter user details after clicking on pay for myself or pickup tab. (not combined order)
  const {
    viewOrder,
    cartDetailsPartner1,
    cartDetailsPartner2,
    user,
    isLoading,
    saveUserAddress,
    checkAddressAvailability,
    setCheckoutDetailConfirmed,
    fetchAddressAutoComplete,
  } = props

  const [errorPhone, setError] = useState(true)
  const [errorMsg, setErrorMsg] = useState("")
  const [errorAddress, setErrorAddress] = useState("")

  const reg = new RegExp("[-() ]", "g")

  const {
    values,
    handleChange,
    touched,
    errors,
    handleBlur,
    isSubmitting,
    isValid,
    validateUserAddress,
  } = props
  const myAddress = _.get(user, "address.user_address", "")

  const [
    isEditAddressModalVisible,
    setEditAddressModalVisibility,
  ] = React.useState(false)

  const [
    partnerCheckedOutModalVisibility,
    setpartnerCheckedOutModalVisibility,
  ] = useState(false)
  const [
    userCancellingModalVisibility,
    setuserCancellingModalVisibility,
  ] = useState(false)

  const [address, setAddress] = React.useState(myAddress)
  const [addressOptions, setAddressOptions] = useState([])
  const [isChecked, setIsChecked] = useState(true)
  const [mobileNumber, setMobileNumber] = useState(
    _.get(props.user, "phone_number", "")
  )
  const { Option } = AutoComplete
  const myDetails = {}
  const yourDetails = {}

  const { dateState, partnerState, userState } = React.useContext(
    FirebaseContext
  )
  const userUUID = _.get(userState, "userDetails.uuid")
  const partnerUUID = _.get(partnerState, "userDetails.uuid")
  const acceptedRestaurant = _.get(
    dateState,
    FIREBASE_STATE_KEYS.ACCEPTED_RESTAURANT,
    {}
  )
  const isOrderCombined = _.get(
    dateState,
    `${FIREBASE_STATE_KEYS.IS_ORDER_COMBINED}`,
    false
  )

  const previousAcceptedRestaurant = usePrevious(acceptedRestaurant)
  const partnerFirebaseCart = _.get(
    partnerState,
    FIREBASE_STATE_KEYS.DELIVERY_COM_CART,
    {}
  )
  const partnerName = getPartnerNameorNickName(partnerState)
  const partnerGender = getGenderSpecificMessage(
    _.get(partnerState, "userDetails.gender")
  )
  const partnerGenderPosessive = getGenderSpecificMessage(
    _.get(partnerState, "userDetails.gender"),
    "POSSESSIVE"
  )
  const partnerWant = getGenderSpecificMessage(
    _.get(partnerState, "userDetails.gender"),
    "WANT"
  )
  const isCombined = _.get(dateState, "isOrderCombined")
  useEffect(() => {
    if (
      dateState &&
      dateState.payStatus &&
      dateState.payStatus.status === "CANCELLED" &&
      !userCancellingModalVisibility
    ) {
      setpartnerCheckedOutModalVisibility(true)
    }
  }, [dateState, userCancellingModalVisibility])

  useEffect(() => {
    if (!acceptedRestaurant) {
      return
    }
    const acceptedRestaurantId =
      acceptedRestaurant[FIREBASE_STATE_KEYS.RESTAURANT_ID]
    if (
      acceptedRestaurantId &&
      !_.isEqual(previousAcceptedRestaurant, acceptedRestaurant)
    ) {
      viewOrder(false, acceptedRestaurantId)
    }
  }, [acceptedRestaurant])

  const userActiveRoute = _.get(userState, FIREBASE_STATE_KEYS.ACTIVE_ROUTE)
  useEffect(() => {
    if (userActiveRoute !== "/checkout/detail")
      props.history.push(userActiveRoute)
  })

  myDetails["cart"] = _.get(
    userState,
    `${FIREBASE_STATE_KEYS.DELIVERY_COM_CART}`
  )
  myDetails["displayName"] = _.get(
    userState,
    `${FIREBASE_STATE_KEYS.USER_DETAILS}.${FIREBASE_STATE_KEYS.DISPLAY_NAME}`
  )
  myDetails["last_name"] = _.get(
    userState,
    `${FIREBASE_STATE_KEYS.USER_DETAILS}.last_name`
  )
  yourDetails["cart"] = _.get(
    partnerState,
    `${FIREBASE_STATE_KEYS.DELIVERY_COM_CART}`
  )
  yourDetails["displayName"] = _.get(
    partnerState,
    `${FIREBASE_STATE_KEYS.USER_DETAILS}.${FIREBASE_STATE_KEYS.DISPLAY_NAME}`
  )
  yourDetails["last_name"] = _.get(
    userState,
    `${FIREBASE_STATE_KEYS.USER_DETAILS}.last_name`
  )

  const navigateToCheckoutPage = () => {
    if (
      props.date &&
      props.date.payStatus &&
      props.date.payStatus.status === "SELF"
    ) {
      if (props.date && props.date.payStatus) {
        const partnerState = _.get(
          props.date.payStatus,
          `${partnerUUID}.state`,
          "CHECKOUT"
        )
        if (partnerState === "CHECKOUT") {
          // Since you are the second user to CHECKOUT, Clear Pay Status and update your current page
          FirebaseService.write(
            null,
            `${FirebaseService.getDefaultPath()}${[
              FIREBASE_STATE_KEYS.PAY_STATUS,
            ]}`
          )
        } else {
          // Since you are the user to go back to CHECKOUT, Update your current page
          FirebaseService.write(
            {
              ...props.date.payStatus,
              [userUUID]: { state: "CHECKOUT" },
            },
            `${FirebaseService.getDefaultPath()}${[
              FIREBASE_STATE_KEYS.PAY_STATUS,
            ]}`
          )
        }
      }
      FirebaseService.setActiveRoute("/checkout")
      props.history.push("/checkout")
    } else {
      if (
        props.date &&
        props.date.payStatus &&
        (props.date.payStatus.status === "BOTH" ||
          props.date.payStatus.status === "COMBINED")
      ) {
        setuserCancellingModalVisibility(true)
      }
    }
  }

  const navigateToWaitState = async () => {
    values.paymentPhone = mobileNumber
    if (props.date && props.date.payStatus) {
      if (
        props.date.payStatus.status === "SELF" ||
        props.date.payStatus.status === "COMBINED"
      ) {
        FirebaseService.write(
          {
            ...props.date.payStatus,
            [userUUID]: {
              state: "PAYMENT",
              ...values,
            },
          },
          `${FirebaseService.getDefaultPath()}${[
            FIREBASE_STATE_KEYS.PAY_STATUS,
          ]}`
        )
        FirebaseService.setActiveRoute("/checkout/payment")
        props.history.push("/checkout/payment")
      } else {
        FirebaseService.write(
          {
            ...props.date.payStatus,
            [userUUID]: {
              state: "WAITING",
              ...values,
            },
          },
          `${FirebaseService.getDefaultPath()}${[
            FIREBASE_STATE_KEYS.PAY_STATUS,
          ]}`
        )

        await FirebaseService.setActiveRoute("/checkout/wait")
        props.history.push("/checkout/wait")
      }
    }
    props.saveUserpaymentDetails(values)
    if (isChecked) {
      props.savePreferences(
        {
          displayName: values.firstName,
          lastName: values.lastName,
          dateOfBirth: user.dob,
          pronoun: user.gender,
          lat: "",
          long: "",
        },
        user.id,
        false
      )
    }
    setCheckoutDetailConfirmed(true)
  }

  const handleSearch = async value => {
    setAddress(value)
    if (value) {
      let addresses = await fetchAddressAutoComplete(value)
      setAddressOptions(addresses.data)
    }
  }

  const children = addressOptions.map(address => (
    <Option key={address.id} value={address.description}>
      {address.description}
    </Option>
  ))

  const onSelect = value => {
    setAddress(value)
  }

  const toggleSave = () => {
    setIsChecked(!isChecked)
  }
  const calculateTotal = (isCombined, combinedTotal, total) => {
    // total values are coming as string Tofixed will break it.
    if (isCombined) {
      let value = parseFloat(combinedTotal)
      return value.toFixed(2)
    }
    let totalValue = parseFloat(total)
    return totalValue.toFixed(2)
  }

  const renderBlockingModal = () => {
    return (
      <>
        <BlockingModal
          withOptions
          title={GO_BACK_FROM_CHECKOUT_DETAIL}
          content={GO_BACK_CONTENT(partnerName)}
          blockingModalVisibility={userCancellingModalVisibility}
          continueHandler={async () => {
            await FirebaseService.write(
              {
                ...props.date.payStatus,
                [userUUID]: { state: "CHECKOUT" },
                status: "CANCELLED",
              },
              `${FirebaseService.getDefaultPath()}${[
                FIREBASE_STATE_KEYS.PAY_STATUS,
              ]}`
            )
            setCheckoutDetailConfirmed(false)
            await FirebaseService.setActiveRoute("/checkout")
            props.history.push("/checkout")
          }}
          cancelHandler={() => setuserCancellingModalVisibility(false)}
        />
        <BlockingModal
          title={PARTNER_GO_BACK_FROM_CHECKOUT_DETAIL(
            partnerName,
            partnerGenderPosessive,
            partnerWant
          )}
          blockingModalVisibility={partnerCheckedOutModalVisibility}
          continueHandler={async () => {
            await FirebaseService.write(
              {
                ...props.date.payStatus,
                [userUUID]: { state: "CHECKOUT" },
                status: "CANCELLED",
              },
              `${FirebaseService.getDefaultPath()}${[
                FIREBASE_STATE_KEYS.PAY_STATUS,
              ]}`
            )
            await FirebaseService.setActiveRoute("/checkout")
            props.history.push("/checkout")
          }}
        />
      </>
    )
  }

  const showPageHeader = () => {
    const showPartnerAway = checkCheckoutPartnerAway(partnerState, dateState)
    const payStatus = _.get(dateState, "payStatus.status", "")
    const userPickedTab = _.get(dateState, "payStatus.userPickedTab", "")

    return (
      <PageHeader
        onClick={() => navigateToCheckoutPage()}
        btnSize="small"
        icon={<ArrowLeftOutlined />}
        btnText={BACK_FROM_CHECKOUT_DETAIL}
        disabled={showPartnerAway}
        headerText={
          dateState && _.get(dateState, "payStatus.status", "") === "SELF"
            ? YOU_PAY_SELF
            : dateState &&
              _.get(dateState, "payStatus.userPickedTab", "") ===
                _.get(user, "uuid", "")
            ? YOU_PAY_BOTH
            : dateState
            ? PARTNER_PAY_BOTH(partnerName, partnerGender)
            : ""
        }
      />
    )
  }

  const renderHeadingSection = () => {
    const userAddress = _.get(user, "address.user_address", "")
    return (
      <>
        <div className="sub-heading">
          <Text textType="pageHeading">{CONFIRM_DETAILS}</Text>
        </div>
        <div className="checkout-address">
          <Text textType="smallTextPrimary">{USER_ADDRESS(userAddress)}</Text>
          <EditFilled
            onClick={() => setEditAddressModalVisibility(true)}
            className="hideon-small"
          />
          <Modal
            title={CHANGE_ADDRESS_TITLE}
            visible={isEditAddressModalVisible}
            keyboard={false}
            footer={[
              <Button
                key="save"
                disabled={!address}
                onClick={() => {
                  validateUserAddress(address, "", () => {
                    checkAddressAvailability(
                      address,
                      _.get(
                        cartDetailsPartner1,
                        "merchant_info.id",
                        _.get(cartDetailsPartner2, "merchant_info.id")
                      )
                    )
                    saveUserAddress({ address })
                    setEditAddressModalVisibility(false)
                  }).then(response => {
                    if (_.get(response, "status") === 400)
                      setErrorAddress(response.data.error)
                  })
                }}
              >
                {SAVE_BUTTON}
              </Button>,
              <Button
                key="cancel"
                btnType="bordered"
                onClick={() => {
                  setAddress(myAddress)
                  setEditAddressModalVisibility(false)
                }}
              >
                {CANCEL}
              </Button>,
            ]}
            onCancel={() => {
              setAddress(myAddress)
              setEditAddressModalVisibility(false)
            }}
          >
            <div className="address-change">
              <Text className="address-change-text">
                {CHANGE_ADDRESS_WARNING}
              </Text>
              <AutoComplete
                value={address}
                className="search-bar"
                onSearch={handleSearch}
                onSelect={onSelect}
                onChange={() => {
                  if (errorAddress) {
                    setErrorAddress("")
                  }
                }}
                allowClear={true}
              >
                {address ? children : null}
              </AutoComplete>
              {errorAddress && (
                <div className="address-error">{errorAddress}</div>
              )}
            </div>
          </Modal>
        </div>
      </>
    )
  }

  const checkoutDetailsLeftPart = () => {
    return (
      <div className="checkout-order-details">
        {renderHeadingSection()}
        {!props.isAddressDeliverable && (
          <div className="label-error">{ADDRESS_NOT_DELIVERABLE}</div>
        )}
        <div className="user-data">
          <form autoComplete="off">
            <div className="names-row">
              <Form.Item
                help={
                  touched.firstName && errors.firstName
                    ? errors.firstName
                    : null
                }
                validateStatus={
                  touched.firstName && errors.firstName ? "error" : undefined
                }
              >
                <Input
                  name="firstName"
                  placeholder={FIRST_NAME}
                  value={values.firstName}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={errors.firstName && true}
                />
              </Form.Item>
              <Form.Item
                help={
                  touched.lastName && errors.lastName ? errors.lastName : null
                }
                validateStatus={
                  touched.lastName && errors.lastName ? "error" : undefined
                }
              >
                <Input
                  name="lastName"
                  onBlur={handleBlur}
                  value={values.lastName}
                  onChange={handleChange}
                  placeholder={LAST_NAME}
                  error={errors.lastName && true}
                />
              </Form.Item>
            </div>
            <Form.Item
              help={
                touched.paymentEmail && errors.paymentEmail
                  ? errors.paymentEmail
                  : null
              }
              validateStatus={
                touched.paymentEmail && errors.paymentEmail
                  ? "error"
                  : undefined
              }
            >
              <Input
                name="paymentEmail"
                value={values.paymentEmail}
                onChange={handleChange}
                placeholder={EMAIL}
                onBlur={handleBlur}
                error={errors.paymentEmail && true}
              />
            </Form.Item>
            <Form.Item
              help={
                touched.paymentPhone && errors.paymentPhone
                  ? errors.paymentPhone
                  : null
              }
              validateStatus={
                touched.paymentPhone && errors.paymentPhone
                  ? "error"
                  : undefined
              }
            >
              <div className="phone-input">
                <PhoneInput
                  placeholder={PHONE_REQUIRED_PLACEHOLDER}
                  format={true}
                  separateDialCode={true}
                  defaultValue={values.paymentPhone || ""}
                  numberType={"MOBILE"}
                  onPhoneNumberBlur={(isPhoneValid, number) => {
                    if (!isPhoneValid && !number) {
                      setError(true)
                      setErrorMsg(PHONE_NUMBER_REQUIRED)
                    }
                  }}
                  onPhoneNumberChange={(
                    isPhoneValid,
                    number,
                    data,
                    formattedValue
                  ) => {
                    if (isPhoneValid) {
                      let paymentPhone = formattedValue.replace(reg, "")
                      setMobileNumber(paymentPhone)
                      setError(false)
                      // handleChange(formattedValue)
                    } else {
                      setError(true)
                      setErrorMsg(INVALID_MOBILE)
                    }
                  }}
                  onSelectFlag={(number, obj, formattedValue, isWrong) => {
                    if (number !== "" && !isWrong) {
                      setError(!isWrong)
                      setErrorMsg(INVALID_FLAG_SELECTED)
                    } else {
                      setErrorMsg("")
                    }
                  }}
                  error={errorPhone && errorMsg}
                />
              </div>
            </Form.Item>
            <div className="checkbox-row" onClick={toggleSave}>
              <img
                onClick={toggleSave}
                src={isChecked ? checkbox : checkboxUntick}
                alt="check"
              />
              <Text className="text-description" textType="sectionTextPrimary">
                {SAVE_FUTURE_TEXT}
              </Text>
            </div>
          </form>
        </div>
      </div>
    )
  }

  const combinedOrderedView = () => {
    const myTotal = _.get(myDetails, "cart.total", 0)
    const combinedTotal =
      _.get(myDetails, "cart.total", 0) +
      _.get(yourDetails, "cart.total", 0) -
      _.get(myDetails, "cart.delivery_fee", 0)
    const cart = _.get(myDetails, "cart.cart", [])
    const combinedPrices = createCombinedOrderPriceBreakdown(
      myDetails.cart,
      partnerFirebaseCart
    )
    return (
      <div className="checkout-order">
        <div className="checkout-content">
          <div className="sub-heading">
            <Text className="checkout-label">{ORDER_LABEL}</Text>
          </div>
          <div className="combined-order-content">
            <Text>{"You"}</Text>
            <div className={`separator user`}></div>
            <OrderDetails
              isOrderCombined={isOrderCombined}
              subtotal={_.get(myDetails, "cart.subtotal", 0)}
              cart={cart}
              name={YOUR}
            />
            <Text className="checkout-label">
              {PARTNER_ORDERS(partnerName)}
            </Text>
            <div className={`separator partner`}></div>
            <OrderDetails
              isOrderCombined={isOrderCombined}
              subtotal={_.get(partnerFirebaseCart, "subtotal", 0)}
              cart={partnerFirebaseCart.cart}
              name={`${partnerName}'s`}
            />
            <PriceBreakdown
              {...combinedPrices}
              isOrderCombined={isOrderCombined}
              customOrderWrapperClass="single-view"
            />
          </div>
        </div>
        <Text className="order-total">
          <span>{TOTAL}</span>
          <span>${calculateTotal(isCombined, combinedTotal, myTotal)}</span>
        </Text>
      </div>
    )
  }

  const individualOrderview = () => {
    const myTotal = _.get(myDetails, "cart.total", 0)
    const combinedTotal =
      _.get(myDetails, "cart.total", 0) +
      _.get(yourDetails, "cart.total", 0) -
      _.get(myDetails, "cart.delivery_fee", 0)
    const cart = _.get(myDetails, "cart.cart", [])
    return (
      <div className="checkout-order">
        <div className="checkout-content">
          <div className="sub-heading">
            <Text className="checkout-label">{ORDER_LABEL}</Text>
          </div>
          <div className="combined-order-content">
            <OrderDetails
              isOrderCombined={isOrderCombined}
              subtotal={_.get(myDetails, "cart.subtotal", 0)}
              cart={cart}
              name={YOUR}
              customOrderWrapperClass="single-view"
            />
            <PriceBreakdown
              {...myDetails.cart}
              isOrderCombined={isOrderCombined}
              customOrderWrapperClass="single-view"
            />
          </div>
        </div>
        <Text className="order-total">
          <span>{TOTAL}</span>
          <span>${calculateTotal(isCombined, combinedTotal, myTotal)}</span>
        </Text>
      </div>
    )
  }

  const checkoutDetailsRightPart = () => {
    return isOrderCombined ? combinedOrderedView() : individualOrderview()
  }

  const getCheckoutDetailContent = () => {
    return (
      <React.Fragment>
        <CheckoutPartnerAway {...props} />
        {renderBlockingModal()}
        <div className="order-receipt">
          {showPageHeader()}
          <RestaurantNameHeader restaurants={props.restaurants} />
          <div className="checkout-detail-container">
            <div className="checkout-detail">
              {checkoutDetailsLeftPart()}
              {checkoutDetailsRightPart()}
            </div>
          </div>
          <div className="confirm-button">
            <Button
              btnType="primary"
              btnSize="large"
              onClick={navigateToWaitState}
              disabled={
                !props.isAddressDeliverable ||
                isSubmitting ||
                !isValid ||
                errorPhone
              }
            >
              {CONFIRM_BUTTON}
            </Button>
            <Text>{NOT_CHARGED}</Text>
          </div>
        </div>
      </React.Fragment>
    )
  }

  return (
    <div id="CheckoutPage">{isLoading ? null : getCheckoutDetailContent()}</div>
  )
}

const CheckoutDetailPage = withFormik({
  enableReinitialize: true,
  validateOnMount: true,
  validationSchema: CheckPaymentDetailsValidation,
  mapPropsToValues: props => ({
    firstName: _.get(props.user, "display_name", ""),
    paymentEmail: _.get(props.user, "email", ""),
    lastName: _.get(props.user, "last_name", ""),
    paymentPhone: _.get(props.user, "phone_number", ""),
  }),
})(S)

const mapStateToProps = state => {
  const {
    orderAndPayments: {
      cartDetailsPartner1,
      cartDetailsPartner2,
      isLoading,
      payStatus,
      partnerConfirmedCheckoutDetails,
      checkoutHeaderMessage,
      isAddressDeliverable,
    },
    planDinner: { restaurantSuggested, restaurants },
    invitePeople: { partnerDetails },
    auth: { user, partner },
  } = state
  return {
    cartDetailsPartner1,
    cartDetailsPartner2,
    restaurantSuggested,
    partnerDetails,
    user,
    partner,
    isLoading,
    payStatus,
    partnerConfirmedCheckoutDetails,
    checkoutHeaderMessage,
    isAddressDeliverable,
    restaurants,
  }
}
export default connect(mapStateToProps, {
  viewOrder,
  checkAddressAvailability,
  saveUserAddress,
  validateUserAddress,
  invitePartnerToChat,
  setCheckoutDetailConfirmed,
  saveUserpaymentDetails,
  savePreferences,
  fetchAddressAutoComplete,
})(CheckoutDetailPage)
